export default __webpack_public_path__ + "3b3cc5bfa207c951dd869cc3ea71d32f.mp3";